export class ProductVariants extends HTMLElement {
    constructor() {
        super();
    }

    getVariantsData(reference: any) {        
        const target = reference.querySelector('[type="application/json"]');

        if(target) {
            return JSON.parse(target.textContent as string);
        }
    }

    onVariantSelect(variantId: string, reference: any) {
        const variantsData = this.getVariantsData(reference);
        // const targetVariant = variantsData.find((variant: any) => {
        //     return variantId == variant.id
        // })

        variantsData.forEach((variant: any) => {
            if (variantId == variant.id) {
                this.updateProductPrice(variant, reference);
                this.updateUrl(variant, reference);
                this.removeErrorMessage(variant, reference)
            }
        })
    }

    updateProductPrice(variantObject: any, reference: any) {
        const price = (variantObject.price / 100).toFixed(2);
        const salePrice = variantObject.compare_at_price / 100 === 0 ? 0 : (variantObject.compare_at_price / 100).toFixed(2);

        const priceContainer = reference.querySelector("product-price");

        const domains = [
          'lovetodream-au',
          'love-to-dream-uk',
          'lovetodream-eu'
        ];

        const priceHtml = `
            <product-price class="product-price">

                ${
                    salePrice ?
                    `
                        <div class="product-price__compare">
                            ${domains.some(domain => Shopify.shop.includes(domain)) ? "RRP " : ""}${window.currencySymbol || '$'}${ salePrice }
                        </div>
                    `
                    :
                    ``
                }
            
                <div class="product-price__sale">
                    ${window.currencySymbol || '$'}${ price }
                </div>
            </product-price>
        `;

        priceContainer.outerHTML = priceHtml;
       
    }

    updateUrl(variantObject: any, reference: any) {
        
    }

    removeErrorMessage(variantObject: any, reference: any) {
        const errorWrappers = reference.querySelectorAll(".product-form__error-message-wrapper");
        errorWrappers.forEach((errorWrapper: any) => {
            const errorMessage = errorWrapper.querySelector(".product-form__error-message");
        
            errorMessage.innerHTML = "";
            errorWrapper.classList.add("hidden");
        })
    }
}
  
customElements.define('product-variants', ProductVariants);
